import { render, staticRenderFns } from "./ProduceToBeBought.vue?vue&type=template&id=8ab5f6c8&scoped=true&"
import script from "./ProduceToBeBought.vue?vue&type=script&lang=js&"
export * from "./ProduceToBeBought.vue?vue&type=script&lang=js&"
import style0 from "./ProduceToBeBought.vue?vue&type=style&index=0&id=8ab5f6c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab5f6c8",
  null
  
)

export default component.exports